export default "__VITE_ASSET__C$ZSjZo6__"